export enum MarketingNotificationsStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
}

export type User = {
  id: string
  email: string
  roles?: string[]
  firstName?: string
  lastName?: string
  marketingNotifications?: MarketingNotificationsStatus
  marketingNotificationsUpdatedAt?: string | null
}

export enum Role {
  FEATURE_FLAG_ADMIN = 'FEATURE_FLAG_ADMIN',
  PARTNER = 'PARTNER',
  CUSTOMER = 'CUSTOMER',
  DISTRIBUTOR = 'DISTRIBUTOR',
  RESELLER = 'RESELLER',
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
  ADMIN = 'ADMIN',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
}

export const adminRoles = [Role.ACCOUNT_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN]
